



























































































import type { Opdracht } from "../../types/opdrachten/Opdracht";

import Vue from "vue";
import ListItem from "../interface/ListItem.vue";
import RatioView from "../interface/RatioView.vue";
import MandatenView from "./MandatenView.vue";

export default Vue.extend({
    name: "opdracht-card-content",
    props: {
        opdracht: {
            type: Object as () => Opdracht,
            required: true,
        },
    },
    components: {
        ListItem,
        MandatenView,
        RatioView,
    },
    methods: {
        isOpdPercShown(opdracht: Opdracht): boolean {
            return opdracht.opdPerc > 0;
        },
        isOpdUrenShown(opdracht: Opdracht): boolean {
            return opdracht.opdUren > 0;
        },
        isNprShown(opdracht: Opdracht): boolean {
            return opdracht.nprPerc > 0 || opdracht.nprUren > 0;
        },
        isNprPercShown(opdracht: Opdracht): boolean {
            return opdracht.opdPerc > 0;
        },
    }
});
